<template>
  <div class="collection-container">
    <!--
    <el-row>
      <span class="router-title">{{ exhibitionName }}的展品列表</span>
    </el-row>
    -->
    <el-row class="tfam-table-search-row" :class="{ padding: searchBarComputed }">
      <div class="tfam-table-search">
        <span class="ti-search"></span>
        <input class="form-control" aria-describedby="addon-right addon-left" placeholder="搜尋">
      </div>
    </el-row>
    <el-row v-if="isOlder">
      <el-table
        :data="showOlderCollectionList"
        v-loading="listLoading"
        :show-header="false"
        :row-style="rowStyle"
        :cell-style="cellStyle"
        empty-text="無資料"
        @row-click="rowClickOlder"
        style="width: 100%;">
        <el-table-column
          type="image"
          width="80">
          <template slot-scope="scope">
            <div class="image-content list-image demo-image__error">
              <div class="block">
                <el-image :src="getImageUrl(scope.row)" fit="cover">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="名稱"
          min-width="300">
          <template slot-scope="scope">
            <div class="collection-title">
              <span class="collection-title-cht">{{ scope.row.name ? scope.row.name.text_cht : ''}}</span>
              <br>
              <span class="collection-title-eng">{{ scope.row.name ? scope.row.name.text : ''}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="count"
          label="點擊次數"
          width="30">
          <template slot-scope="scope">
            <span>{{ scope.row | tapCountFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="events"
          label="events">
          <template slot-scope="scope">
            <span class="tfam-link">未綁定</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :page-size="10"
        :pager-count="11"
        :hide-on-single-page="true"
        :current-page.sync="olderListQuery.page"
        :total="olderCollectionList.length"
        layout="prev, pager, next"
        @current-change="handleOlderFilter">
      </el-pagination>
    </el-row>
    <el-row v-else>
      <el-table
        class="collectionTable"
        :class="{ active: showCollectionList.length > 0}"
        :data="showCollectionList"
        v-loading="listLoading"
        :show-header="false"
        :row-style="rowStyle"
        empty-text="無資料"
        style="width: 100%;">
        <el-table-column
          prop="sort"
          label="排序"
          width="50">
          <template slot-scope="scope">
            <div class="sortable-content">
              <span class="ti-menu"></span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          type="image"
          width="80">
          <template slot-scope="scope">
            <div class="image-content list-image demo-image__error">
              <div class="block">
                <el-image :src="getImageUrl(scope.row)" fit="cover">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="名稱"
          width="300">
          <template slot-scope="scope">
            <div class="collection-title" @click="goCollection(scope.row['collection_id'])">
              <span class="collection-title-cht">{{ scope.row | titleFilter }}</span>
              <span v-if="scope.row['rooms'].length > 0" class="collection-rooms">
                #{{ roomContentFilter(scope.row) }}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="count"
          label="點擊次數"
          width="70">
          <template slot-scope="scope">
            <span>點擊次數:{{ scope.row | tapCountFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="events"
          label="events">
          <template slot-scope="scope">
            <div
              class="beacon-events"
              :class="{ active: scope.row['beacons'] && scope.row['beacons'].length > 0 }"
              @click="handleBindingBeacon(scope.row)">
              <span class="tfam-link">{{ scope.row['beacons'] | filterBeaconNames }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <div class="create-new" @click="createNew()">
      <span class="tfam-new"></span>
    </div>
    <el-dialog
      title="選擇iBeacon"
      :visible.sync="beaconDialogVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :center="true">
      <beacon-select
        :binding-data="collectionData"
        binding-type="collection"
        @update="finishBeaconBinding"></beacon-select>
    </el-dialog>
  </div>
</template>

<script>
import exhibitionJSON from '../../transData/exhibitions'
import collectionJSON from '../../transData/collections'
import { parseTime } from '../../utils'
import { fetchCollectionList, updateCollection } from "../../api/collection";
import { fetchExhibition } from "../../api/exhibition";
import { getGCPFileUrl } from "../../api/attachment";
import { fetchFloorList } from "../../api/floor";
import BeaconSelect from "../Componments/BeaconSelect";
import Sortable from 'sortablejs';

export default {
  name: "CollectionList",
  components: {BeaconSelect},
  computed: {
    rowStyle: function () {
      return {
        'height': '80px',
        'cursor': 'default'
      }
    },
    searchBarComputed: function () {
      return !(this.isOlder || this.showCollectionList.length === 0);
    }
  },
  data() {
    return {
      activeName: 'now',
      exhibitionName: '',
      collectionList: [],
      showCollectionList: [],
      olderCollectionList: [],
      showOlderCollectionList: [],
      enableTransfer: this.$store.getters.user.name === 'rideawavefun',
      isOlder: this.$route.name === 'v1_collections',
      exhibitionId: this.$route.params.exhibitionId,
      olderListQuery: {
        page: 1
      },
      listLoading: false,
      beaconDialogVisible: false,
      collectionData: undefined,
      floorList: []
    }
  },
  filters: {
    titleFilter: function (row) {
      const filter = row['collectionLangs'].filter(x => x['language_key'] === 'ZH_TW');
      if (filter.length > 0) {
        return filter[0]['title'] ? filter[0]['title'] : '-'
      } else {
        return '-'
      }
    },
    engTitleFilter: function (row) {
      const filter = row['collectionLangs'].filter(x => x['language_key'] === 'EN');
      if (filter.length > 0) {
        return filter[0]['title'] ? filter[0]['title'] : '-'
      } else {
        return '-'
      }
    },
    openFilter: function (row) {
      return parseTime(row['open_start_at'], '{y}/{m}/{d}') + '-' + parseTime(row['open_end_at'], '{y}/{m}/{d}')
    },
    filterBeaconNames: function (beacons) {
      if (beacons && beacons.length > 0) {
        const names = [];
        for (const i in beacons) {
          names.push(beacons[i]['title'])
        }
        return names.join('，')
      } else {
        return '未綁定'
      }
    },
    tapCountFilter: function (row) {
      let count = 0
      for (const i in row.collectionLangs) {
        count += row.collectionLangs[i]['tap_count']
      }
      return count
    }
  },
  mounted() {
    this.getFloorList();
    this.$route.meta.name = '展品列表';
    this.isOlder = this.$route.name === 'v1_collections';
    if (this.isOlder) {
      this.getCollectionListFromOlder()
    } else {
      this.getCollectionList();
    }
    // this.getCollectionListFromOlder();
  },
  methods: {
    roomContentFilter(row) {
      console.log('roomContentFilter');
      console.log(row['rooms']);
      const roomContent = [];
      console.log(this.floorList);
      if (this.floorList.length > 0 && row['rooms'].length > 0) {
        for(const i in this.floorList) {
          const floor = this.floorList[i];
          const filter = floor['rooms'].filter(x => row['rooms'].includes(x['room_id']));
          if (filter.length > 1) {
            roomContent.push(floor['name'])
          } else if (filter.length > 0) {
            roomContent.push(floor['name'] + '(' + filter[0]['section'] + ')')
          }
        }
      }
      console.log(roomContent);
      return roomContent.join('|')
    },
    finishBeaconBinding(val) {
      this.beaconDialogVisible = false;
      this.collectionData = undefined;
      if (val['reload']) {
        this.getCollectionList()
      }
    },
    handleOlderFilter() {
      this.showOlderCollectionList = this.olderCollectionList.slice(
        (this.olderListQuery.page - 1) * 10, (this.olderListQuery.page) * 10);
    },
    getImageUrl(data) {
      if (this.isOlder) {
        if (data['general_information'] &&
          data['general_information']['coverphoto'] &&
          data['general_information']['coverphoto']['value']) {
          const imagePath = 'image/' + data['general_information']['coverphoto']['value'] + '/0.jpg';
          return getGCPFileUrl(imagePath);
        } else {
          return ''
        }
      } else {
        if (data['images'].length > 0) {
          return getGCPFileUrl(data['images'][0]['name']);
        } else {
          return ''
        }
      }
    },
    handleSwitchListClick() {
      console.log(this.activeName);
    },
    cellStyle(row, column, rowIndex, columnIndex) {
      if (row.column.label === 'collectionAndResponse') {
        return 'text-align:right; padding: 10px'
      } else {
        return ''
      }
    },
    getCollectionListFromOlder() {
      const exhibition = exhibitionJSON.filter(x => x['_id'] === this.exhibitionId)[0];
      this.exhibitionName = exhibition.title.text_cht;
      this.$root.routerName = this.exhibitionName;
      this.olderCollectionList = collectionJSON.filter(x => x['root'] === this.exhibitionId);
      this.handleOlderFilter();
    },
    getFloorList() {
      const filter = {
        include: ['rooms']
      };
      fetchFloorList(filter).then(response => {
        this.floorList = response.data;
      }).catch(err => {
      })
    },
    getCollectionList() {
      this.listLoading = true;
      const exhibitionFilter = {
        include: [{
          relation: 'exhibitionLangs',
          scope: {
            where: {
              language_key: 'ZH_TW'
            }
          }
        }, {
          relation: 'collections',
          scope: {
            include: ['collectionLangs', 'beacons'],
            order: ['index_sort ASC']
          }
        }]
      };
      fetchExhibition(this.exhibitionId, exhibitionFilter).then(response => {
        const exhibition = response.data;
        this.listLoading = false;
        this.exhibitionName = exhibition['exhibitionLangs'][0]['title'];
        this.$root.eventBus.$emit('routerName', this.exhibitionName);
        this.collectionList = response.data.collections;
        this.showCollectionList = JSON.parse(JSON.stringify(response.data['collections']));
        this.setupTableSortable();
      }).catch(err => {
        this.listLoading = false;
      });
    },
    setupTableSortable() {
      console.log('setupTableSortable');
      const el = document.querySelectorAll('.el-table__body-wrapper > table > tbody')[0];
      // const el = document.querySelectorAll('.list')[0];
      const _this = this;
      const sortable = Sortable.create(el, {
        handle: ".ti-menu",
        onUpdate: function (evt) {
          const targetRow = _this.collectionList.splice(evt.oldIndex, 1)[0];
          _this.collectionList.splice(evt.newIndex, 0, targetRow);
          _this.handleUpdateSort();
        },
      });
    },
    handleUpdateSort() {
      this.updateSort().then(response => {
      }).catch(err => {
      })
    },
    updateSort: async function() {
      try {
        const promiseArray = [];
        for (let i = 0; i < this.collectionList.length; i++) {
          const collection = this.collectionList[i];
          if (collection['index_sort'] === null || collection['index_sort'] !== i) {
            promiseArray.push(updateCollection(collection['collection_id'], {
              index_sort: i
            }))
          }
        }
        await Promise.all(promiseArray);
        return Promise.resolve(true)
      } catch (e) {
        return Promise.reject(e);
      }
    },
    rowClick(row) {
      // this.goCollection(row['collection_id']);
    },
    handleBindingBeacon(row) {
      this.collectionData = JSON.parse(JSON.stringify(row));
      this.beaconDialogVisible = true;
    },
    rowClickOlder(row) {
      this.goCollection(row['_id']);
    },
    goCollection(collectionId) {
      if (this.isOlder) {
        this.$router.push({
          path: '/exhibitions/v1/' + this.exhibitionId + '/collections/' + collectionId
        })
      } else {
        this.$router.push({
          path: '/exhibitions/v2/' + this.exhibitionId + '/collections/' + collectionId
        })
      }
    },
    createNew() {
      this.goCollection('new')
    }
  }
}
</script>

<style lang="scss">
.collection-container {
  .tfam-table-search-row {
    padding-left: 0;
  }
  .tfam-table-search-row.padding {
    animation-name:search-bar-padding;
    animation-duration:100ms;
    animation-fill-mode: forwards;
  }
  @keyframes search-bar-padding {
    from {
      padding-left: 0;
    }
    to {
      padding-left: 50px;
    }
  }
  .collectionTable {
    .sortable-content {
      background: #f4f3ef;
      width: 100%;
      height: 80px;
      text-align: center;
      line-height: 80px;
      span {
        visibility: hidden;
        cursor: move;
      }
    }
    .el-table__row:hover {
      .sortable-content {
        span {
          visibility: visible;
        }
      }
    }
    table {
      border-collapse:separate;
      border-spacing:0 10px;
      background-color: #f4f3ef;
      padding-right: 1px;
      width: 100% !important;
      td {
        cursor: default;
        padding: 0;
        .cell {
          padding: 0;
          border-width: 0;
        }
      }
    }
  }
  .collection-title {
    padding: 10px;
    width: fit-content;
    cursor: pointer;
    .collection-title-cht {
      display: block;
      /*font-weight: bold;*/
      font-size: 16px;
      color: black;
    }
    .collection-rooms {
      font-size: 14px;
      font-style: italic;
      color: black;
    }
  }
  .el-tabs__item.is-active {
    color: #27A5C1;
  }
  .el-tabs__item:hover {
    color: #27A5C1;
  }
  .el-tabs__active-bar {
    background-color: #27A5C1;
  }
  .el-pagination {
    float: right;
    .btn-prev {
      background: rgba(0, 0, 0, 0.01);
    }
    .el-dialog, .el-pager li {
      background: rgba(0, 0, 0, 0.01);
    }
    .btn-next {
      background: rgba(0, 0, 0, 0.01);
    }
  }
}
</style>
